import { Layer, Line, Stage, Rect, Transformer } from "react-konva";
import React, { useEffect, useState } from "react";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { URLImage } from "./URLImage";
import { pieces } from "../data/data";
import { v4 as uuidv4 } from "uuid";

const INITIAL_STATE = {
  timerActive: true,
  currentInterruption: null,
  x: 50,
  y: 50,
  isDragging: false,
  images: [],
  isDrawing: false,
  lines: [],
};


const WordPlayground = (props) => {
  const stageRef = React.useRef();
  const [images, setImages] = useState([]);

  const [lines, setLines] = useState([]);
  const isDrawing = React.useRef(false);

  const [enableDrawing, setEnableDrawing] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const [mouseY, setMouseY] = useState(null);
  const [mouseX, setMouseX] = useState(null);
  const [contextImageId, setContextImageId] = useState(null);

  const [deselectAll, setDeselectAll] = useState(false);


  const [selectedId, selectShape] = React.useState(null);
  const [nodesArray, setNodes] = React.useState([]);
  const imageNodeMapRef = React.useRef({});

  const trRef = React.useRef(null);
  const layerRef = React.useRef();
  const Konva = window.Konva;

  React.useEffect(() => {
    if (props.results.lines !== lines && props.results.lines !== undefined) {
      let newLines = props.results.lines.slice();
      setLines(newLines);
    }
    if (props.results.images !== images && props.results.images !== undefined) {
      let newImages = props.results.images.slice();
      setImages(newImages);
    }
  }, [props.results]);

useEffect(() => {
  const tr = getTransformer();
  const layer = getLayer();
  const node = selectedId ? imageNodeMapRef.current[String(selectedId)] : null;

  if (!tr || !layer) return;

  if (typeof tr.nodes === "function") {
    tr.nodes(node ? [node] : []);
  } else if (!node) {
    if (typeof tr.detach === "function") tr.detach();
  } else if (typeof tr.setNode === "function") {
    tr.setNode(node);
  } else if (typeof tr.attachTo === "function") {
    tr.attachTo(node);
  }

  if (typeof tr.forceUpdate === "function") {
    tr.forceUpdate();
  }

  layer.batchDraw();
}, [selectedId]);

const setImageNodeRef = (id) => (node) => {
  const key = String(id);

  if (!node) {
    delete imageNodeMapRef.current[key];
    return;
  }

  imageNodeMapRef.current[key] =
    typeof node.getNode === "function" ? node.getNode() || node : node;
};

  const handleTransformEnd = (event) => {
  let scaleX = event.target.attrs.scaleX;
  let scaleY = event.target.attrs.scaleY;
  let rotation = event.target.attrs.rotation;

  const id = event.target.attrs.id;

  const slicedImages = images.slice();

  const imageInQuestion = slicedImages.find((i) => String(i.id) === String(id));
  const index = slicedImages.indexOf(imageInQuestion);

  let newImage = {
    ...imageInQuestion,
    scaleX: scaleX,
    scaleY: scaleY,
    rotation: rotation,
    x: event.target.x(),
    y: event.target.y(),
  };

  slicedImages[index] = newImage;

  if (props.control) {
    setImages(slicedImages);
  }
  props.updateImages("update", slicedImages);

  setTimeout(() => {
    const tr = getTransformer();
    const layer = getLayer();
    if (tr && typeof tr.forceUpdate === "function") {
      tr.forceUpdate();
    }
    if (layer) {
      layer.batchDraw();
    }
  }, 0);
};
  const onDragStartImage = (e) => {
    if (isDrawing.current === true) {
      return false;
    }
  };

  const attachTransformerToNodes = (nodes) => {
  const tr = getTransformer();
  const layer = getLayer();



  if (!tr || !layer) {
    return;
  }

  if (!nodes || nodes.length === 0) {
    if (typeof tr.detach === "function") {
      tr.detach();
      //console.log("transformer detached");
    } else if (typeof tr.nodes === "function") {
      tr.nodes([]);
      //console.log("transformer nodes([])");
    }
    layer.batchDraw();
    return;
  }

  if (nodes.length === 1) {
    const node = nodes[0];

    

    if (typeof tr.attachTo === "function") {
      tr.attachTo(node);
      //console.log("used attachTo");
    } else if (typeof tr.setNode === "function") {
      tr.setNode(node);
      //console.log("used setNode");
    } else if (typeof tr.nodes === "function") {
      tr.nodes([node]);
      //console.log("used nodes([node])");
    }

    

    layer.batchDraw();
    return;
  }

  if (typeof tr.nodes === "function") {
    tr.nodes(nodes);
    //console.log("used nodes(multi)");
  } else if (typeof tr.attachTo === "function") {
    tr.attachTo(nodes[0]);
    //console.log("fallback attachTo first node");
  }

  layer.batchDraw();
};

  const sendToBack = (e) => {
    const id = contextImageId;

    const items = images.slice();

    const item = items.find((i) => String(i.id) === String(id));
    const index = items.indexOf(item);
    // remove from the list:
    items.splice(index, 1);

    let newImage = {
      ...item,
    };

    // add to the back
    items.unshift(newImage);
    if (props.control) {
      setImages(items);
    }
    props.updateImages("update", items);
    handleContextClose();
  };

  const handleImageDragEnd = (e) => {
    const id = e.target.attrs.id;

    const items = images.slice();
    const item = items.find((i) => String(i.id) === String(id));
    const index = items.indexOf(item);
    // remove from the list:
    //items.splice(index, 1);

    let newImage = {
      ...item,
      x: e.target.x(),
      y: e.target.y(),
    };

    items[index] = newImage;

    setDeselectAll(true);
    // add to the top
    //items.push(newImage);
    if (props.control) {
      setImages(items);
    }
    props.updateImages("update", items);
  };

  const checkDeselect = (e) => {
    // deselect when clicked on empty area
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      selectShape(null);
      const tr = getTransformer();
const layer = typeof layerRef.current?.getNode === "function"
  ? layerRef.current.getNode()
  : layerRef.current;

if (tr) {
  if (typeof tr.detach === "function") {
    tr.detach();
  } else if (typeof tr.nodes === "function") {
    tr.nodes([]);
  }
}

if (layer) {
  layer.batchDraw();
}
      setNodes([]);
      // layerRef.current.remove(selectionRectangle);
    }
  };

  const selectionRectRef = React.useRef();
  const selection = React.useRef({
    visible: false,
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  });

  const updateSelectionRect = () => {
    const node = selectionRectRef.current;
    node.setAttrs({
      visible: selection.current.visible,
      x: Math.min(selection.current.x1, selection.current.x2),
      y: Math.min(selection.current.y1, selection.current.y2),
      width: Math.abs(selection.current.x1 - selection.current.x2),
      height: Math.abs(selection.current.y1 - selection.current.y2),
      fill: "rgba(0, 161, 255, 0.3)"
    });
    node.getLayer().batchDraw();
  };

  const oldPos = React.useRef(null);
  
const onMouseDown = (e) => {

  if (props.control === false) {
    return;
  }

  const stage = e.target.getStage();
  const clickedOnStage = e.target === stage;

  if (clickedOnStage) {
    selectShape(null);
  }
};

  const onMouseMove = (e) => {
    if (!selection.current.visible) {
      return;
    }
    const pos = e.target.getStage().getPointerPosition();
    selection.current.x2 = pos.x;
    selection.current.y2 = pos.y;
    updateSelectionRect();
  };

  const clearSelection = () => {
  const tr = getTransformer();
  const layer = getLayer();
  if (!tr || !layer) return;

  if (typeof tr.detach === "function") {
    tr.detach();
  } else if (typeof tr.nodes === "function") {
    tr.nodes([]);
  }

  if (typeof tr.forceUpdate === "function") {
    tr.forceUpdate();
  }

  layer.batchDraw();
};

const attachSelection = (node) => {
  const tr = getTransformer();
  const layer = getLayer();
  if (!tr || !layer || !node) return;

  if (typeof tr.detach === "function") {
    tr.detach();
  } else if (typeof tr.nodes === "function") {
    tr.nodes([]);
  }

  if (typeof tr.attachTo === "function") {
    tr.attachTo(node);
  } else if (typeof tr.setNode === "function") {
    tr.setNode(node);
  } else if (typeof tr.nodes === "function") {
    tr.nodes([node]);
  }

  if (typeof tr.forceUpdate === "function") {
    tr.forceUpdate();
  }

  layer.batchDraw();
};

const onMouseUp = () => {
  selection.current.visible = false;
  updateSelectionRect();
};


const getTransformer = () => trRef.current;

const getLayer = () => {
  if (!layerRef.current) return null;
  return typeof layerRef.current.getNode === "function"
    ? layerRef.current.getNode()
    : layerRef.current;
};

  const onClickTap = (e) => {
  const stage = e.target.getStage();

  selection.current.visible = false;
  updateSelectionRect();

  if (e.target === stage) {
    //attachTransformerToNodes([]);
    return;
  }

  const pieceNode =
    e.target.findAncestor(".selectable-piece") ||
    (e.target.hasName && e.target.hasName("selectable-piece") ? e.target : null);

  if (!pieceNode) {
    return;
  }

  //console.log("clicked pieceNode", pieceNode);
  //attachTransformerToNodes([pieceNode]);
};

  const addElementsToCanvas = (els, results) => {
    const newImages = [];

    if ( results.images !== undefined ){
      results.images.forEach((el) => {
        let newImage = {
          ...el
        };
        newImages.push(newImage);
      });
    } else {
      if ( props.hasControl ){
        els.forEach((el) => {
          let newImage = {
            ...el
          };
          newImages.push(newImage);
        });
        //console.log('newImages: ', newImages);
        props.updateImages("add", newImages);
      }
    }

    
    
  };

  useEffect(() => {
    addElementsToCanvas(pieces, props.results);
  }, []);

  const openContextMenu = (event, contextImageId) => {
    setContextImageId(contextImageId);
    setMouseY(event.clientY - 4);
    setMouseX(event.clientX - 2);
  };

  const handleContextClose = () => {
    setMouseY(null);
    setMouseX(null);
    setContextImageId(null);
    setDeselectAll(true);
  };

  const resetDeselectAll = () => {
    setDeselectAll(false);
  };

  
  

  return (
    <div>
      <Menu
        keepMounted
        open={mouseY !== null && mouseX !== null}
        onClose={handleContextClose}
        anchorReference="anchorPosition"
        anchorPosition={
          mouseY !== null && mouseX !== null
            ? { top: mouseY, left: mouseX }
            : undefined
        }
      >
        <MenuItem onClick={sendToBack}>Send to Back</MenuItem>
        {/* <MenuItem onClick={deletePiece}>Remove this Piece</MenuItem> */}
        <MenuItem>--------------</MenuItem>
        <MenuItem onClick={handleContextClose}>Cancel</MenuItem>
      </Menu>

      <div
        style={{ height: "760px", width: "900px", marginTop: "20px" }}
        id="white-board"
        onDrop={(e) => {
          // e.preventDefault();
          // console.log("dragged el: ", props.draggedEl);
          // stageRef.current.setPointersPositions(e);
          // addElementToCanvas(props.draggedEl);
        }}
        onDragOver={(e) => e.preventDefault()}
      >
        <div className="whiteboard-base-text">
          {props.title === undefined ? "SEEING THE POINT" : props.title}
        </div>
        <Stage
          width={900}
          height={700}
          onMouseDown={onMouseDown}
          ref={stageRef}
          id="theStage"
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onTouchStart={checkDeselect}
        >
          <Layer ref={layerRef}>
            {images.map((image) => {
  return (
    <URLImage
      key={String(image.id)}
      isSelected={String(selectedId) === String(image.id)}
      onSelect={(id) => {
        selectShape(String(id));
      }}
      isDrawing={isDrawing.current}
      image={image}
      handleDragEnd={handleImageDragEnd}
      dragStart={onDragStartImage}
      transformEnd={handleTransformEnd}
      control={props.control}
      openContext={openContextMenu}
    />
  );
})}
      
          <Rect
  ref={selectionRectRef}
  visible={false}
  listening={false}
  fill="rgba(0,161,255,0.3)"
/>
          </Layer>
         
        </Stage>
      </div>
    </div>
  );
};

export default WordPlayground;
